import { Component, OnInit } from '@angular/core';
import { Coupons } from 'src/app/_models/coupons.model';
import { CouponsService } from 'src/app/_services/coupons.service';
import { environment, baseUrl } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { sortTable } from 'src/app/helpers/sort-table';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { CouponDomainModalComponent } from '../coupon-domain-modal/coupon-domain-modal.component';
import { Router } from '@angular/router';
import { TableColumn } from '@swimlane/ngx-datatable';
import { ISmartTableMessage } from 'src/app/_interfaces/smart-table/i-message';
import { ICouponDTO } from 'src/app/_interfaces/coupons/i-general-coupon';
import { DatePipe } from '@angular/common';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';

@Component({
  selector: 'app-coupons-list',
  templateUrl: './coupons-list.component.html',
  styleUrls: ['./coupons-list.component.scss'],
})
export class CouponsListComponent implements OnInit {
  pageTitle: string = 'Coupons';
  isActive: string = '0';
  domainIds: string = '0';
  filteredCouponsArray: ICouponDTO[] = [];
  noMatchingResult: boolean = false;
  invertSort: boolean = true;
  tableTitle: string = 'All Coupons';
  filterTypes = [
    { key: 'all', value: 'All' },
    { key: 'active', value: 'Active Coupons' },
    { key: 'test', value: 'Lab Tests Coupons' },
    { key: 'appointment', value: 'Appointments Coupons' },
  ];
  modalRef: BsModalRef;
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number;
  isFilterBtnData: boolean = false;
  choicesObj = {
    statusAll: false,
    statusActive: false,
    domainAll: false,
    domainAppointment: false,
    domainTest: false,
  };
  searchValue: string = '';
  totalItems: number;
  columns: TableColumn[];
  messages: ISmartTableMessage = {
    emptyMessage: 'Sorry, we could not find any matching coupons 🥳',
    totalMessage: 'total',
    selectedMessage: ''
  }

  constructor(
    private adminCouponsService: CouponsService,
    public toastr: ToastrService,
    private modalService: BsModalService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit(): void {
    this.getPromoCodes(this.currentPage, this.pageSize, this.searchValue);
  }

  getPromoCodes(currentPage, pageSize, searchString) {
    this.adminCouponsService
      .getPromoCodes(currentPage, pageSize, searchString)
      .subscribe(
        (res) => {
          this.noMatchingResult = false;

          this.filteredCouponsArray = res?.data?.items;
          this.initilaizeColumns();

          if (!this.filteredCouponsArray.length) {
            this.noMatchingResult = true;
          }

          this.currentPage = res?.data?.pagination.currentPage;
          this.totalPages = res?.data?.pagination.totalPages;
          this.totalItems = res?.data.pagination.totalItems;
        },
        (error) => {
          this.noMatchingResult = true;
          this.filteredCouponsArray = [];
        }
      );
  }

  getAllFilteredCoupons(isActive, domainIds, currentPage, pageSize) {
    this.adminCouponsService
      .filterPromoCodes(isActive, domainIds, currentPage, pageSize)
      .subscribe(
        (res) => {
          this.noMatchingResult = false;

          this.filteredCouponsArray = res?.data?.items;
          this.initilaizeColumns();

          if (!this.filteredCouponsArray.length) {
            this.noMatchingResult = true;
          }

          this.invertSorting();
          this.currentPage = res?.data?.pagination.currentPage;
          this.totalPages = res?.data?.pagination.totalPages;
          this.totalItems = res?.data?.pagination.totalItems;
        },
        (error) => {
          this.noMatchingResult = true;
          this.filteredCouponsArray = [];
        }
      );
  }

  onChangePage(pageDetails: ISmartTablePagination) {
    this.currentPage = pageDetails.offset + 1;

    if (this.isFilterBtnData) {
      this.getAllFilteredCoupons(
        this.isActive,
        this.domainIds,
        this.currentPage,
        this.pageSize
      );
    } else {
      this.getPromoCodes(this.currentPage, this.pageSize, this.searchValue);
    }
  }

  onSearchCoupon(searchString) {
    this.searchValue = searchString;
    this.choicesObj = {
      statusAll: false,
      statusActive: false,
      domainAll: false,
      domainAppointment: false,
      domainTest: false,
    };
    this.isActive = '0';
    this.domainIds = '0';

    this.isFilterBtnData = false;
    this.currentPage = 1;

    this.getPromoCodes(this.currentPage, this.pageSize, searchString);
  }

  handleCouponClick(selectedCoupon) {
    let coupon = selectedCoupon.selected[0];
    if (coupon.domainId == 1) {
      this.router.navigate(['/appointment-coupon-details/', coupon.id]);
    } else if (coupon.domainId == 2) {
      this.router.navigate(['/test-coupon-details/', coupon.id]);
    }
  }

  onStatusBtnChange(value) {
    this.searchValue = '';
    this.isFilterBtnData = true;
    this.isActive = value;
    this.currentPage = 1;

    this.getAllFilteredCoupons(
      this.isActive,
      this.domainIds,
      this.currentPage,
      this.pageSize
    );
  }

  onDomainBtnChange(value) {
    if (value == '0') {
      this.tableTitle = 'All Coupons';
    } else if (value == '1') {
      this.tableTitle = 'Appointments Coupons';
    } else if (value == '2') {
      this.tableTitle = 'Lab Tests Coupons';
    }

    this.searchValue = '';
    this.isFilterBtnData = true;
    this.domainIds = value;
    this.currentPage = 1;

    this.getAllFilteredCoupons(
      this.isActive,
      this.domainIds,
      this.currentPage,
      this.pageSize
    );
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredCouponsArray = sortTable(
      this.filteredCouponsArray,
      'startDate',
      this.invertSort
    );
  }

  chooseCouponDomain(event) {
    event.stopPropagation();

    const initialState: ModalOptions<any> = {
      keyboard: true,
      class: 'modal-dialog-centered',
    };

    this.modalRef = this.modalService.show(
      CouponDomainModalComponent,
      initialState
    );
  }

  initilaizeColumns() {
    this.columns = [
      { prop: 'couponName', name: 'English Name' },
      { prop: 'arCouponName', name: 'Arabic Name' },
      { prop: 'couponCode', name: 'Code' },
      {
        prop: 'startDate', name: 'Start Date',
        pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y") }
      },
      {
        prop: 'endDate', name: 'End Date',
        pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y") }
      },
      { prop: 'discountPercentage', name: 'Percentage' },
      { prop: 'ceiling', name: 'Ceiling' },
      {
        prop: 'usageTypeId', name: 'Use', pipe: {
          transform: (val) => {
            if (val == 1) return "Single Use";
            else if (val == 2) return "Once Per Customer ";
            else return "Unlimited";
          }
        }
      },
      {
        prop: 'domainId', name: 'Domain',
        pipe: { transform: (val) => val == 1 ? "Appointments" : "Tests" }
      }
    ];
  }
}
